import { connect } from 'react-redux';
import GiftCertificateForm from '../components/GiftCertificateForm';
import withMobile from '../hocs/withMobile';
import { setCertHolder, setCertText } from '../store/certificate/slice';
import { getIsClientConfirmed } from '../store/view/selectors';
import { getIsCertificateCreated } from '../store/certificate/selectors';

const mapStateToProps = (state) => ({
  isClientConfirmed: getIsClientConfirmed(state),
  isCreated: getIsCertificateCreated(state),
});

const mapDispatchToProps = (dispatch) => ({
  setHolder: (payload) => dispatch(setCertHolder(payload)),
  setText: (payload) => dispatch(setCertText(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(GiftCertificateForm));
